import queryString from 'query-string'

import { get } from '../utils'

export interface EmbedListArgs {
  limit: number
  offset: number
  /** Empty means "every partner" -- the param is omitted rather than sent blank. */
  partnerIds?: number[]
}

/**
 * The public, unauthenticated conversation feed behind /embed/conversations.
 *
 * Built with query-string rather than a template literal. The app's other
 * conversation client (api/ConversationsApi.js:6-8) interpolates its params by
 * hand, which is why it has no way to express a list at all -- and why an
 * embed that had to name two partners could not use it.
 *
 * `partner_ids` goes over the wire as one comma-joined value. query-string
 * percent-encodes the comma (`partner_ids=68%2C621`); Rails decodes it back to
 * `"68,621"` before the controller sees it, which is verified against
 * production. Passing a JS array here instead would make query-string emit the
 * repeat-key form `partner_ids=68&partner_ids=621` -- the API tolerates that
 * too, but the comma form is what the admin generator puts in the snippet, so
 * the embed and the generated URL stay byte-identical.
 *
 * Instance methods on a singleton rather than the static class the older .js
 * clients use: every TypeScript client in this directory is written this way
 * (TracksApi, StoriesApi, DocumentsApi), because a static-only class trips
 * @typescript-eslint/no-extraneous-class -- a rule the .js ones never see.
 */
class EmbedConversationsApi {
  getAll({ limit, offset, partnerIds = [] }: EmbedListArgs) {
    const params = queryString.stringify({
      limit,
      offset,
      site_name: global.siteName,
      ...(partnerIds.length > 0 ? { partner_ids: partnerIds.join(',') } : {})
    })

    return get(`/embed/conversations?${params}`)
  }
}

export default new EmbedConversationsApi()
